import Vue from 'vue'



import CsInput from '@/components/Forms/CsInput';
Vue.component('CsInput', CsInput);

import CsInputCheck from '@/components/Forms/CsInputCheck';
Vue.component('CsInputCheck', CsInputCheck);

import CsInputRadio from '@/components/Forms/CsInputRadio';
Vue.component('CsInputRadio', CsInputRadio);

import CsInputConfirm from '@/components/Forms/CsInputConfirm';
Vue.component('CsInputConfirm', CsInputConfirm);

import CsInputToggle from '@/components/Forms/CsInputToggle';
Vue.component('CsInputToggle', CsInputToggle);

import CsTextarea from '@/components/Forms/CsTextarea';
Vue.component('CsTextarea', CsTextarea);


import Datepicker from '@/components/Forms/Datepicker';
Vue.component('Datepicker', Datepicker);

import Dropdown from '@/components/Forms/Dropdown';
Vue.component('Dropdown', Dropdown);

import MultiSelect from '@/components/Forms/MultiSelect';
Vue.component('MultiSelect', MultiSelect);

import Timepicker from '@/components/Forms/Timepicker';
Vue.component('Timepicker', Timepicker);



// WEBPACK FOOTER //
// ./src/components/Forms/index.js